import React from 'react';
import yaml from 'js-yaml';
import './AppToolJson.css';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { prism } from 'react-syntax-highlighter/dist/esm/styles/prism';

class AppToolJson extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      formattedJson: "",
      yamlOutput: "",
      error: null,
      originalJson: "",
      outputFormat: "json", // 'json' or 'yaml'
      copySuccess: '', // to show a success message after copying
    }
    this.handleChange = this.handleChange.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.toggleOutputFormat = this.toggleOutputFormat.bind(this);
  }

  formatJSON(jsonStr) {
    if (!jsonStr) {
        this.setState({ formattedJson: "", yamlOutput: "", error: null, outputFormat: "json" });
        return;
    }

    let obj;

    // Try parsing as YAML/JSON directly. yaml.load handles both.
    try {
        const loaded = yaml.load(jsonStr);
        if (typeof loaded === 'object' && loaded !== null) {
            obj = loaded;
        }
    } catch (e) {
        // Not valid YAML/JSON. Keep going.
    }

    // If not parsed, try base64 decoding then parsing as YAML/JSON.
    if (!obj) {
        try {
            // Trim to handle potential whitespace around base64 string
            const decodedStr = atob(jsonStr.trim());
            const loaded = yaml.load(decodedStr);
            if (typeof loaded === 'object' && loaded !== null) {
                obj = loaded;
            }
        } catch (e) {
            // Not valid base64 or not valid YAML/JSON after decoding.
        }
    }

    if (obj) {
        try {
            const formatted = JSON.stringify(obj, null, 2);
            const yamlString = yaml.dump(obj);
            this.setState({ formattedJson: formatted, yamlOutput: yamlString, error: null });
        } catch (e) {
            this.setState({ formattedJson: '', yamlOutput: '', error: "Error during output generation: " + e.message });
        }
    } else {
        this.setState({ formattedJson: '', yamlOutput: '', error: "Invalid JSON, YAML, or Base64-encoded JSON/YAML." });
    }
  }

  handleChange(e){
    const jsonStr = e.target.value;
    this.setState({ originalJson: jsonStr, outputFormat: "json", copySuccess: '' });
    this.formatJSON(jsonStr);
  }

  copyToClipboard() {
    const content = this.state.outputFormat === 'json' ? this.state.formattedJson : this.state.yamlOutput;
    navigator.clipboard.writeText(content).then(() => {
      this.setState({ copySuccess: 'Copied!' });
      setTimeout(() => this.setState({ copySuccess: '' }), 2000);
    }, () => {
      this.setState({ copySuccess: 'Failed to copy!' });
      setTimeout(() => this.setState({ copySuccess: '' }), 2000);
    });
  }

  toggleOutputFormat() {
    this.setState(prevState => ({
      outputFormat: prevState.outputFormat === 'json' ? 'yaml' : 'json'
    }));
  }

  render() {
    const { originalJson, outputFormat, formattedJson, yamlOutput, error, copySuccess } = this.state;
    const showResult = originalJson.length > 0;
    const currentOutput = outputFormat === 'json' ? formattedJson : yamlOutput;

    return (
      <div id="tool_json">
        <div id="content_box">
          <textarea 
              type="text" 
              rows="8" 
              placeholder="请输入待格式的json/base64后的json/yaml字符串。纯前端格式化，数据安全有保障：）" 
              cols="130" 
              onChange={this.handleChange}
              value={originalJson}
              className={!showResult ? 'empty-input' : ''}
          ></textarea>
          {showResult && (
            error ? (
              <pre className="error-message">{error}</pre>
            ) : (
              <div>
                <div className="toolbar">
                  <button onClick={this.copyToClipboard}>Copy</button>
                  <button onClick={this.toggleOutputFormat}>
                    {outputFormat === 'json' ? 'Convert to YAML' : 'Convert to JSON'}
                  </button>
                  {copySuccess && <span className="copy-success">{copySuccess}</span>}
                </div>
                <SyntaxHighlighter
                  language={outputFormat}
                  style={prism}
                  showLineNumbers
                  customStyle={{
                    width: '1100px',
                    margin: '10px auto',
                    border: '1px solid #ddd'
                  }}
                >
                  {currentOutput}
                </SyntaxHighlighter>
              </div>
            )
          )}
        </div>
      </div>
    );
  }
}

export default AppToolJson;